import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'country' })
export class CountryTransform implements PipeTransform {

    transform(key: string): string {

        const countries = {
            ARG: 'Argentina',
            BRA: 'Brazil',
            GBR: 'United Kingdom',
            MEX: 'Mexico'
        };

        return countries[key] || key;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/country.pipe.ts